<template>
	<el-collapse class="tab_item" v-model="activeName" accordion>
		<template v-if="sdata.mtrlFactorys.length">
			<el-collapse-item :title="item.factoryDesc" :name="item.materialFactoryId" v-for="(item,index) in sdata.mtrlFactorys" :key="index">
				<table class="tab_detail">
					<tr>
						<th>创建日期</th><td>{{sdata.createDate}}</td>
						<th>创建人员名</th><td>{{sdata.createUserName}}</td>
					</tr>
					<tr>
						<th>上次更改的日期</th><td>{{sdata.lastModifyDate}}</td>
						<th>厂内生产时间</th><td>{{sdata.factoryProdDate}}</td>
					</tr>
					<tr>
						<th>最大批量</th><td>{{sdata.maxBatchSize}}</td>
						<th>最小批量</th><td>{{sdata.minBatch}}</td>
					</tr>
					<tr>
						<th>安全库存</th><td>{{sdata.safetyStock}}</td>
						<th>部件废品百分数</th><td>{{sdata.compoWastePercent}}</td>
					</tr>
					<tr>
						<th>发货库存地点</th><td>{{sdata.deliveryStockAddr}}</td>
						<th>发货单位</th><td>{{sdata.forwardingUnitDesc}}</td>
					</tr>
					<tr>
						<th>当前期间的会计年度</th><td>{{sdata.currAccountYear}}</td>
						<th>当前记帐期间</th><td>{{sdata.currPostingPeriod}}</td>
					</tr>
					<tr>
						<th>允许少于交货百分比</th><td>{{sdata.allowLessDeliPercent}}</td>
						<th>超量交货容差限制</th><td>{{sdata.allowMoreDeliPercent}}</td>
					</tr>
					<tr>
						<th>评估类别</th><td>{{sdata.assessClassify}}</td>
						<th>BOM版本</th><td>{{sdata.bomVersion}}</td>
					</tr>
					<tr>
						<th>工厂中允许负库存</th><td>{{sdata.allowNegativeStock}}</td>						
					</tr>				
				</table>
			</el-collapse-item>
		</template>
		<p v-else class="no_res">暂无数据</p>	 
	</el-collapse>
</template>

<script>
export default{
	props:{
		sdata:{
			type:Object,
			default:()=>{
				return {}
			}
		}
	},
	data(){
		return {
			activeName: '1'
		};
	},
	created(){		
		console.log(this.sdata);
	}
}
</script>

<style>
</style>
